document.addEventListener("DOMContentLoaded", function() {
    if ($("body").hasClass("header-transparent-true")) {
        var body = document.body;
        function addClassOnScroll() {
            var body = document.body;
            var scrollPosition = window.scrollY || document.documentElement.scrollTop;
            if (scrollPosition > 50) {
                body.classList.add("opaque");
            } else {
                body.classList.remove("opaque");
            }
        }
        window.addEventListener("scroll", addClassOnScroll);

        if (window.scrollY > 50 || document.documentElement.scrollTop > 50) {
            body.classList.add("opaque");
        }
    }

    $(".nav-toggle").click(function () {
        $(this).find("i").toggleClass("fa-bars fa-times");
        $(".nav-content-wrapper").fadeToggle(500);
        $("body").toggleClass("menu-active");
    });

    $('.nav-list-item-toggle').click(function () {
        $(this).toggleClass('toggled');
        $(this).next('ul').toggleClass('show-menu');
    });


    // Search //
    $('.search-reveal').click(function () {
        if ($(window).width() > 1200) {
            $(this).children("i").toggleClass("fa-magnifying-glass fa-times");
            $(".search-btn").toggleClass("inactive");
            $("#headerSearchText").focus();
            $(".js-nav-search").toggleClass("is-revealed");
        }
    });
});